module.exports = __webpack_public_path__ + "static/media/hw_ru_41.e11aa673.flv";